import NewInbox from './components/NewInbox';
import ProcessMapViewer from './components/ProcessMapViewer';
import CaseDetails from './components/CaseDetails';
import Supervisor from './components/Supervisor';
import CaseCreate from './components/CaseCreate';

// const NewInbox = Loadable({
//   loader: () => import("./components/NewInbox"),
//   loading: Loading
// });
// const ProcessMapViewer = Loadable({
//   loader: () => import("./components/ProcessMapViewer"),
//   loading: Loading
// });
// const CaseDetails = Loadable({
//   loader: () => import("./components/CaseDetails"),
//   loading: Loading
// });

export const routes = [
	{
		path: '/newInbox',
		exact: true,
		component: NewInbox,
		name: 'NewInbox',
	},
	{
		path: '/newInbox/processMap/:appUid/:proUid',
		exact: true,
		component: ProcessMapViewer,
		name: 'ProcessMapViewer',
	},
	{
		path: '/newInbox/detail/:id/:del_index',
		exact: true,
		component: CaseDetails,
		name: 'CaseDetails',
	},
	{
		path: '/newInbox/create/:pro_uid/:tas_uid',
		exact: true,
		component: CaseCreate,
		name: 'CaseCreate',
	},
	// {
	// 	path: '/supervisor',
	// 	exact: true,
	// 	component: Supervisor,
	// 	name: 'Supervisor',
	// },
];
export * from './NewInboxActions';
export * from './newInboxReducer';
